export default [
  {
    label: 'Alteração de preço',
    identifier: 'updatePrice',
    type: 'product',
    hasOptions: true,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      },
      {
        type: 'marketplace',
        identifier: 'skyhub'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'colombo'
      },
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      {
        type: 'marketplace',
        identifier: 'walmart'
      },
      {
        type: 'marketplace',
        identifier: 'madeira'
      },
      {
        type: 'marketplace',
        identifier: 'zoom'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'polishop'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'privalia'
      },
      {
        type: 'marketplace',
        identifier: 'decathlon'
      },
      {
        type: 'marketplace',
        identifier: 'keepRunning'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'comfortflex'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Reprocessar produtos',
    identifier: 'productReprocess',
    type: 'product',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductSource: false,
    hasSourceFilters: false,
    modules: [
      {
        type: 'marketplace',
        identifier: 'amazon'
      }
    ],
    sources: []
  },
  {
    label: 'Alteração de preço com carga',
    identifier: 'feedUpdatePrice',
    type: 'product',
    hasOptions: true,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'carrefour'
      },
      {
        type: 'marketplace',
        identifier: 'leroy'
      },
      {
        type: 'marketplace',
        identifier: 'amazon'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Reprocessar pedidos com arquivo',
    identifier: 'fileReprocessOrder',
    type: 'order',
    hasOptions: true,
    hasModuleFilters: false,
    hasProductSource: true,
    hasSourceFilters: false,
    modules: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Alteração de preço com arquivo',
    identifier: 'fileUpdatePrice',
    type: 'product',
    hasOptions: true,
    hasModuleFilters: false,
    hasProductSource: true,
    hasSourceFilters: false,
    modules: [
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'colombo'
      },
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'skyhub'
      },
      {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      },
      {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      {
        type: 'marketplace',
        identifier: 'walmart'
      },
      {
        type: 'marketplace',
        identifier: 'madeira'
      },
      {
        type: 'marketplace',
        identifier: 'zoom'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'polishop'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'decathlon'
      },
      {
        type: 'marketplace',
        identifier: 'keepRunning'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'comfortflex'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      },
      {
        type: 'marketplace',
        identifier: 'renner'
      },
      {
        type: 'marketplace',
        identifier: 'shein'
      },
      {
        type: 'marketplace',
        identifier: 'tikTokShop'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Reprocessar envio',
    identifier: 'reprocessProduct',
    type: 'product',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'skyhub'
      },
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'colombo'
      },
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'privalia'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      {
        type: 'marketplace',
        identifier: 'walmart'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'madeira'
      },
      {
        type: 'marketplace',
        identifier: 'zoom'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'marketplace',
        identifier: 'polishop'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'decathlon'
      },
      {
        type: 'marketplace',
        identifier: 'keepRunning'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'comfortflex'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      },
      {
        type: 'marketplace',
        identifier: 'shein'
      },
      {
        type: 'marketplace',
        identifier: 'tikTokShop'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Reprocessar envio com carga',
    identifier: 'reprocessFeedProduct',
    type: 'product',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'carrefour'
      },
      {
        type: 'marketplace',
        identifier: 'leroy'
      },
      {
        type: 'marketplace',
        identifier: 'amazon'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Reprocessar preço',
    identifier: 'reprocessPrice',
    type: 'product',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'skyhub'
      },
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'colombo'
      },
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      {
        type: 'marketplace',
        identifier: 'walmart'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'madeira'
      },
      {
        type: 'marketplace',
        identifier: 'zoom'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'marketplace',
        identifier: 'polishop'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'decathlon'
      },
      {
        type: 'marketplace',
        identifier: 'keepRunning'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'comfortflex'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      {
        type: 'marketplace',
        identifier: 'renner'
      },
      {
        type: 'marketplace',
        identifier: 'shein'
      },
      {
        type: 'marketplace',
        identifier: 'tikTokShop'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Reprocessar preço com carga',
    identifier: 'reprocessFeedPrice',
    type: 'product',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'carrefour'
      },
      {
        type: 'marketplace',
        identifier: 'leroy'
      },
      {
        type: 'marketplace',
        identifier: 'amazon'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Reprocessar estoque',
    identifier: 'reprocessStock',
    type: 'product',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'skyhub'
      },
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'colombo'
      },
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      {
        type: 'marketplace',
        identifier: 'walmart'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'madeira'
      },
      {
        type: 'marketplace',
        identifier: 'zoom'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'marketplace',
        identifier: 'polishop'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'decathlon'
      },
      {
        type: 'marketplace',
        identifier: 'keepRunning'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'comfortflex'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      {
        type: 'marketplace',
        identifier: 'renner'
      },
      {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      },
      {
        type: 'marketplace',
        identifier: 'shein'
      },
      {
        type: 'marketplace',
        identifier: 'tikTokShop'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Reprocessar estoque com carga',
    identifier: 'reprocessFeedStock',
    type: 'product',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'carrefour'
      },
      {
        type: 'marketplace',
        identifier: 'leroy'
      },
      {
        type: 'marketplace',
        identifier: 'amazon'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Migração anúncios',
    identifier: 'migrationAnnouncement',
    type: 'product',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductSource: false,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      }
    ]
  },
  {
    label: 'Alteração de redutor',
    identifier: 'updateReducer',
    type: 'product',
    hasOptions: true,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      },
      {
        type: 'marketplace',
        identifier: 'skyhub'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'colombo'
      },
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      {
        type: 'marketplace',
        identifier: 'walmart'
      },
      {
        type: 'marketplace',
        identifier: 'madeira'
      },
      {
        type: 'marketplace',
        identifier: 'zoom'
      },
      {
        type: 'marketplace',
        identifier: 'renner'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'polishop'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'decathlon'
      },
      {
        type: 'marketplace',
        identifier: 'keepRunning'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'comfortflex'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      {
        type: 'marketplace',
        identifier: 'shein'
      },
      {
        type: 'marketplace',
        identifier: 'tikTokShop'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Inativar Produto',
    identifier: 'inactivateProduct',
    type: 'product',
    hasOptions: true,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'renner'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      }
    ]
  },
  {
    label: 'Alteração de redutor com carga',
    identifier: 'feedUpdateReducer',
    type: 'product',
    hasOptions: true,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'carrefour'
      },
      {
        type: 'marketplace',
        identifier: 'leroy'
      },
      {
        type: 'marketplace',
        identifier: 'amazon'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Exportar produtos em CSV',
    identifier: 'exportProductCsv',
    type: 'product',
    hasOptions: true,
    hasModuleFilters: true,
    hasProductCodesFilter: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      },
      {
        type: 'marketplace',
        identifier: 'skyhub'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'colombo'
      },
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'carrefour'
      },
      {
        type: 'marketplace',
        identifier: 'leroy'
      },
      {
        type: 'marketplace',
        identifier: 'amazon'
      },
      {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      {
        type: 'marketplace',
        identifier: 'walmart'
      },
      {
        type: 'marketplace',
        identifier: 'madeira'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      },
      {
        type: 'marketplace',
        identifier: 'zoom'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'tool',
        identifier: 'api'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'polishop'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'decathlon'
      },
      {
        type: 'marketplace',
        identifier: 'keepRunning'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'comfortflex'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      {
        type: 'marketplace',
        identifier: 'shein'
      },
      {
        type: 'marketplace',
        identifier: 'tikTokShop'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Exportar pedidos em CSV',
    identifier: 'exportOrderCsv',
    type: 'order',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductSource: false,
    hasSourceFilters: false,
    modules: [
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      },
      {
        type: 'marketplace',
        identifier: 'skyhub'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'colombo'
      },
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'carrefour'
      },
      {
        type: 'marketplace',
        identifier: 'leroy'
      },
      {
        type: 'marketplace',
        identifier: 'amazon'
      },
      {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      {
        type: 'marketplace',
        identifier: 'walmart'
      },
      {
        type: 'marketplace',
        identifier: 'madeira'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      },
      {
        type: 'marketplace',
        identifier: 'zoom'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'polishop'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'decathlon'
      },
      {
        type: 'marketplace',
        identifier: 'keepRunning'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'comfortflex'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      {
        type: 'marketplace',
        identifier: 'shein'
      },
      {
        type: 'marketplace',
        identifier: 'tikTokShop'
      }
    ],
    sources: []
  },
  {
    label: 'Relatório de status de pedidos',
    identifier: 'reportOrderStatus',
    type: 'order',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductSource: false,
    hasSourceFilters: false,
    modules: [
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      },
      {
        type: 'marketplace',
        identifier: 'skyhub'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'colombo'
      },
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'carrefour'
      },
      {
        type: 'marketplace',
        identifier: 'leroy'
      },
      {
        type: 'marketplace',
        identifier: 'amazon'
      },
      {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      {
        type: 'marketplace',
        identifier: 'walmart'
      },
      {
        type: 'marketplace',
        identifier: 'madeira'
      },
      {
        type: 'marketplace',
        identifier: 'gfg'
      },
      {
        type: 'marketplace',
        identifier: 'zoom'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'polishop'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'decathlon'
      },
      {
        type: 'marketplace',
        identifier: 'keepRunning'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'comfortflex'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      {
        type: 'marketplace',
        identifier: 'renner'
      }
    ],
    sources: []
  },
  {
    label: 'Alteração de status de anúncio',
    identifier: 'changeAnnouncementStatus',
    type: 'product',
    hasOptions: true,
    hasModuleFilters: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  },
  {
    label: 'Remover produto',
    identifier: 'removeProduct',
    type: 'product',
    hasOptions: false,
    hasModuleFilters: true,
    hasProductSource: true,
    hasSourceFilters: true,
    modules: [
      {
        type: 'marketplace',
        identifier: 'netshoes'
      },
      {
        type: 'marketplace',
        identifier: 'amazon'
      },
      {
        type: 'marketplace',
        identifier: 'magalu'
      },
      {
        type: 'marketplace',
        identifier: 'shopee'
      },
      {
        type: 'marketplace',
        identifier: 'renner'
      },
      {
        type: 'marketplace',
        identifier: 'cnova'
      },
      {
        type: 'marketplace',
        identifier: 'ramarim'
      },
      {
        type: 'marketplace',
        identifier: 'centauro'
      },
      {
        type: 'marketplace',
        identifier: 'sicredi'
      },
      {
        type: 'marketplace',
        identifier: 'sicoob'
      },
      {
        type: 'marketplace',
        identifier: 'shein'
      }
    ],
    sources: [
      {
        type: 'ecommerce',
        identifier: 'moovin'
      },
      {
        type: 'ecommerce',
        identifier: 'ecomece'
      },
      {
        type: 'erp',
        identifier: 'tiny'
      },
      {
        type: 'tool',
        identifier: 'api'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/storage/toolBatchActions.js